import {useCourseMemberships} from '@freckle/educator-entities/ts/common/hooks/use-course-memberships'
import {useCourses} from '@freckle/educator-entities/ts/common/hooks/use-courses'
import type {PremiumLicensesAttrs} from '@freckle/educator-entities/ts/common/models/premium-licenses'
import type {CourseAttrs} from '@freckle/educator-entities/ts/roster/models/course'
import type {CourseMembershipAttrs} from '@freckle/educator-entities/ts/roster/models/course-membership'
import type {StudentAttrs} from '@freckle/educator-entities/ts/users/models/student'
import {SidebarSectionMain} from '@freckle/classroom/ts/common/components/sidebar/section-main'
import {ViewStudentApp} from '@freckle/classroom/ts/common/components/sidebar/section-main/view-student-app'
import {WithResources} from '@freckle/classroom/ts/common/components/with-resources'
import {usePremiumLicenses} from '@freckle/classroom/ts/hooks/use-premium-licenses'
import {useStudents} from '@freckle/classroom/ts/hooks/use-students'
import {useTeacher} from '@freckle/classroom/ts/hooks/use-teacher'
import {isMathOnly} from '@freckle/classroom/ts/users/models/teacher'
import {SidebarSectionSubjects} from './section-subjects'
import {
  sidebarNavStyle,
  linkDividerTopStyle,
  linkDividerBottomStyle,
  sidebarWrapperStyle
} from './sidebar.module.scss'

export function Sidebar() {
  const teacher = useTeacher()
  const premiumLicenses = usePremiumLicenses()
  const courses = useCourses()
  const students = useStudents()
  const courseMemberships = useCourseMemberships()

  return (
    <WithResources
      resources={{teacher, premiumLicenses, courses, students, courseMemberships}}
      render={({teacher, premiumLicenses, courses, students, courseMemberships}) => {
        const showOnlyMath = isMathOnly(teacher)
        const sidebarContentCommonProps = {
          courses,
          students,
          courseMemberships,
          showOnlyMath,
          premiumLicenses
        }
        return (
          <div className={`${sidebarWrapperStyle} hidden-print`}>
            <div data-test="sidebar-nav" className={sidebarNavStyle}>
              <SidebarContent {...sidebarContentCommonProps} />
            </div>
          </div>
        )
      }}
    />
  )
}

function SidebarContent(props: {
  courses: CourseAttrs[]
  students: StudentAttrs[]
  courseMemberships: CourseMembershipAttrs[]
  showOnlyMath: boolean
  premiumLicenses: PremiumLicensesAttrs
}) {
  const {courses, students, courseMemberships, showOnlyMath, premiumLicenses} = props
  return (
    <>
      <SidebarSectionMain premiumLicenses={premiumLicenses} />
      <div className={linkDividerTopStyle} />
      <ViewStudentApp {...{courses, students, courseMemberships}} isActive={false} />
      <div className={linkDividerBottomStyle} />
      <SidebarSectionSubjects showOnlyMath={showOnlyMath} />
    </>
  )
}
